import { render, staticRenderFns } from "./InternaMain.vue?vue&type=template&id=14f03e00&scoped=true"
import script from "./InternaMain.vue?vue&type=script&lang=js"
export * from "./InternaMain.vue?vue&type=script&lang=js"
import style0 from "./InternaMain.vue?vue&type=style&index=0&id=14f03e00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f03e00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VMain})
